import { render, staticRenderFns } from "./a.vue?vue&type=template&id=b504d4b8&scoped=true&"
import script from "./a.vue?vue&type=script&lang=js&"
export * from "./a.vue?vue&type=script&lang=js&"
import style0 from "./a.vue?vue&type=style&index=0&id=b504d4b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504d4b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b504d4b8')) {
      api.createRecord('b504d4b8', component.options)
    } else {
      api.reload('b504d4b8', component.options)
    }
    module.hot.accept("./a.vue?vue&type=template&id=b504d4b8&scoped=true&", function () {
      api.rerender('b504d4b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/a.vue"
export default component.exports